export const GAEvents = {
  classesScreen: 'classes_screens',
  share: 'share',
  invite: 'invite',
  logout: 'logout',
  login: 'login',
  ratings: 'ratings',
  refer: 'refer'
};
